import React, { Component } from 'react';

import classNames from 'classnames/bind';
import styles from './Logo.css';
const cx = classNames.bind(styles);

const Logo = ({ color, size }) => {
  return <div className={cx('mfLogo', { wide: size === 'wide' }, { white: color === 'white' })} />;
};

export default Logo;



// WEBPACK FOOTER //
// ./src/script/components/common/Logo.js